/**
 * Reseller onboarding Stripe step — eagerly registers the file route and its
 * `validateSearch` schema; the page component and its atom/RPC imports are
 * deferred to `stripe.lazy.tsx` so they load only with this route, never in the
 * always-loaded `main` chunk (CLA-645).
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";
import { resellerStripeReturnState } from "~/lib/reseller-onboarding-steps.ts";

/**
 * Narrow the Stripe route's search into the optional `state` landing mode.
 * Kept pure (no Schema dependency) for trivial unit testing.
 *
 * @since 1.0.0
 */
export const validateResellerStripeSearch = (
  search: Record<string, unknown>,
): { readonly state?: "return" | "refresh" } => {
  const state = resellerStripeReturnState(search["state"]);
  return state === null ? {} : { state };
};

export const Route = createFileRoute("/clawinstall/reseller_/onboarding/stripe")({
  validateSearch: validateResellerStripeSearch,
});
